import { Box, styled } from '@mui/material';

export const CardAppScreenshots = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(90px, 1fr))',
  gap: '7px',
}));

export const CardAppScreenshotWrapper = styled(Box)(() => ({
  overflow: 'hidden',
  height: '182px',
  width: '90px',
  position: 'relative',
}));
